export default "__VITE_ASSET__xC4xYiEx__"